import React, { useState } from 'react';
import { useDarkMode } from '../contexts/DarkModeContext';

const FAQBox = ({ title = 'Frequently Asked Questions', faqs = [] }) => {
  const { isDarkMode } = useDarkMode();
  const [openIdx, setOpenIdx] = useState(null);

  if (!faqs.length) return null;

  return (
    <section className="max-w-[1495px] mx-auto w-full px-4 sm:px-6 mt-8 sm:mt-12">
      <div className={`rounded-2xl sm:rounded-3xl p-5 sm:p-8 lg:p-10 transition-colors duration-300 shadow-lg ${
        isDarkMode ? 'bg-[#1a1a1a] shadow-2xl shadow-black/30 border border-white/10' : 'bg-white'
      }`}>
        <h2 className={`text-xl sm:text-2xl lg:text-3xl font-extrabold mb-4 sm:mb-6 ${
          isDarkMode ? 'text-white' : 'text-gray-900'
        }`}>{title}</h2>
        <div className="divide-y divide-gray-200 dark:divide-gray-800">
          {faqs.map((item, idx) => (
            <div key={idx} className="py-3 sm:py-4">
              <button
                className={`w-full flex items-start justify-between text-left gap-4 group ${
                  isDarkMode ? 'text-gray-100' : 'text-gray-900'
                }`}
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                aria-expanded={openIdx === idx}
              >
                <span className="inline-flex items-center gap-3">
                  <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-red-600 text-white text-sm font-extrabold">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                  <span className="font-semibold text-base sm:text-lg leading-snug">{item.q}</span>
                </span>
                <span className={`mt-1 inline-flex items-center justify-center w-7 h-7 rounded-full border text-sm flex-shrink-0 ${
                  isDarkMode ? 'border-gray-700 text-gray-300' : 'border-gray-300 text-gray-600'
                }`}>{openIdx === idx ? '-' : '+'}</span>
              </button>
              {openIdx === idx && (
                <div className={`mt-2 sm:mt-3 text-sm sm:text-base leading-relaxed ${
                  isDarkMode ? 'text-gray-300' : 'text-gray-600'
                }`}>
                  {item.a.split('\n').map((line, lineIdx) => (
                    <div key={lineIdx} className={line.trim() === '' ? 'h-2' : ''} dangerouslySetInnerHTML={{ __html: line }} />
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQBox;


